import React from "react";
import {useLanguageForShared} from "../../../../../../../shared/utils/languages/useLanguageForShared";
import {PrescriptionTemplate} from "./PrescriptionTemplate";
import {TemplateBase} from "./TemplateBase";


export function TemplateLOX_TOC({
                                    dataForm,
                                    changeValue,
                                    errors,
                                    setData,
                                    isSubmit,
                                }) {
    const {t} = useLanguageForShared()


    return (
        <>
            <TemplateBase
                dataForm={dataForm}
                changeValue={changeValue}
                errors={errors}
                isSubmit={isSubmit}
                setData={setData}
            >
                <PrescriptionTemplate
                    dataForm={dataForm}
                    changeValue={changeValue}
                    errors={errors}
                    isSubmit={isSubmit}
                    setData={setData}
                    paramsPrescription={{hasStroller: true, title: t('prescription.template.prescriptionLOX')}}
                    type={'LOX'}
                />
                <PrescriptionTemplate
                    dataForm={dataForm}
                    changeValue={changeValue}
                    errors={errors}
                    isSubmit={isSubmit}
                    setData={setData}
                    paramsPrescription={{hasTypeflow: true, title: t('prescription.template.prescriptionTOC')}}
                    type={'TOC'}
                />
            </TemplateBase>
        </>
    );
}
